module.exports = __webpack_public_path__ + "img/cs-icon.9eca93d6.png";